export default "__VITE_ASSET__wLuWU8nw__"